import { useEffect, useState } from 'react';
let dataBaseUrl = 'https://static.sfox.au/data'; //hardcoded for now (trev's idea :D), need to use address inputform in webplatform
export function setDataBaseUrl(url: string) {
	dataBaseUrl = url;
}
/** The most popular countries for address selection */
export const TOP_COUNTRIES: Record<string, string> = {
	AU: 'Australia',
	NZ: 'New Zealand',
	US: 'United States',
	GB: 'United Kingdom',
	CA: 'Canada'
};

/** custom hook, returns undefined if not fetched yet. */
export function useCountryCodeToNameJson() {
	const [countryCodeToNameJson, setCountryCodeToNameJson] = useState<Record<string, string> | undefined>(undefined);
	useEffect(() => {
		fetchCountriesJsonAsync().then(data => setCountryCodeToNameJson(data));
	}, []);
	return countryCodeToNameJson;
}

/** same as {@link useCountryCodeToNameJson} but splits the result into {@link TOP_COUNTRIES} and other countries
 */
export function useCountryCodeToNameJsonSplit() {
	const countryCodeToNameJsonAll = useCountryCodeToNameJson();
	const countryCodeToNameJsonOther = countryCodeToNameJsonAll ? { ...countryCodeToNameJsonAll } : undefined;
	if (countryCodeToNameJsonOther) {
		for (const key in TOP_COUNTRIES) {
			delete countryCodeToNameJsonOther[key];
		}
	}
	const isLoading = countryCodeToNameJsonAll === undefined;
	return { countryCodeToNameJsonTop: TOP_COUNTRIES, countryCodeToNameJsonOther, countryCodeToNameJsonAll, isLoading };
}
/** fetches the country list from blob storage*/
export async function fetchCountriesJsonAsync(): Promise<Record<string, string>> {
	let res = (await fetch(`${dataBaseUrl}/countries.json`)).json();
	return res;
}

/** custom hook, returns undefined if not fetched yet. */
export function useStateCodeToNameJson(country: string | undefined) {
	const [stateCodeToNameJson, setStateCodeToNameJson] = useState<Record<string, string> | undefined>(undefined);
	useEffect(() => {
		if (country) {
			console.log('refetching states');
			fetchStatesJsonByCountryAsync(country)
				.then(data => setStateCodeToNameJson(data))
				.catch(reason => setStateCodeToNameJson(undefined));
		}
	}, [country]);
	return stateCodeToNameJson;
}

/** fetchs the state list based on the country code given */
export async function fetchStatesJsonByCountryAsync(country: string): Promise<Record<string, string>> {
	let res = (await fetch(`${dataBaseUrl}/states/${country}.json`)).json();
	return res;
}
